import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useConfirm } from 'material-ui-confirm'
import { FunctionComponent, useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { notError, notSuccess } from '../../../../utils/notification'
import { swalClose, swalException, swalLoading } from '../../../../utils/swal'
import { apiTipoArticuloRegistro } from '../../api/apiTipoArticuloRegistrado'
import {
  TIPO_ARTICULO_INITIAL_VALUES,
  TipoArticuloInputProps,
  TipoArticuloProps,
} from '../../interfaces'
import { tipoArticuloComposeService } from '../../services/tipoArticuloRegistroComposeService'
import {
  TipoArticuloRegistroValidationSchema,
  tipoArticuloRegistroValidator,
} from '../../validator/tipoArticuloRegistro.validator'
import TipoArticuloForm from '../TipoArticuloForm'

interface OwnProps {
  id: string
  keepMounted: boolean
  open: boolean
  // eslint-disable-next-line no-unused-vars
  onClose: (value?: TipoArticuloProps) => void
}

type Props = OwnProps

/**
 * Formulario para upsert de tipos de articulo
 * @param props
 * @constructor
 */
const TipoArticuloRegistroDialog: FunctionComponent<Props> = (props) => {
  const { onClose, open, ...other } = props

  const form = useForm<TipoArticuloInputProps>({
    defaultValues: { ...TIPO_ARTICULO_INITIAL_VALUES },
    resolver: yupResolver<any, any, any>(TipoArticuloRegistroValidationSchema),
  })
  const confirm = useConfirm()

  /**
   * Guardamos los datos
   * @param values
   */
  const onSubmit: SubmitHandler<TipoArticuloInputProps> = async (values) => {
    try {
      const val = await tipoArticuloRegistroValidator(values)
      if (val.length > 0) {
        notError(val.join('<br>'))
        return
      }

      const codigo = values.codigo
      const apiInput = tipoArticuloComposeService(values)

      const { confirmed } = await confirm()
      if (!confirmed) return

      swalLoading()

      const resp = await apiTipoArticuloRegistro(codigo.toString(), apiInput)

      if (resp) {
        notSuccess('Registro exitoso')
        onClose(resp)
      }
    } catch (e: any) {
      if (e.response?.errors?.[0]?.extensions?.code === 'USER_INPUT_ERROR') {
        notError(e.response.errors[0].message) // Muestra el mensaje de error específico
      } else {
        swalException(e) // Maneja otros errores
      }
    } finally {
      swalClose()
    }
  }

  const onError = (errors: any, e: any) => console.log(errors, e)
  useEffect(() => {
    if (open) {
      form.reset({
        ...TIPO_ARTICULO_INITIAL_VALUES,
      })
    }
  }, [open])

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '100%', maxHeight: '80vh' } }}
      maxWidth="sm"
      open={open}
      {...other}
    >
      <DialogTitle>Nuevo Tipo Articulo</DialogTitle>
      <DialogContent dividers>
        <TipoArticuloForm form={form} handleEdit={false} />
      </DialogContent>
      <DialogActions>
        <Button autoFocus color={'error'} size={'small'} onClick={() => onClose()}>
          Cancelar
        </Button>
        <Button
          onClick={form.handleSubmit(onSubmit, onError)}
          size={'small'}
          style={{ marginRight: 25 }}
          variant={'contained'}
        >
          Registrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TipoArticuloRegistroDialog
